import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute: React.FC<{ element: JSX.Element }> = ({ element }) => {
  const isAuthenticated = localStorage.getItem("user"); // Check if logged in
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
